import { Grid } from "@mui/material";
import React from "react";
import ARMainGroupInput from "../../../CustomARMainGroup/ARMainGroupInput";
import ARListCode from "../../../CustomARMainGroup/Components/ARListCode";
import PropTypes from "prop-types";

export default function ConditionARSelect(props) {
  const { defaultValue, title } = props;
  const [arMainGroup, setARMainGroup] = React.useState("");
  const [arTableData, setArTableData] = React.useState([]);
  const [sendData, setSendData] = React.useState(false);
  React.useEffect(() => {
    if (sendData === true) {
      props.result({ arMainGroup: arMainGroup, arTableData: arTableData });
    }
    return () => {};
  }, [arMainGroup, arTableData]);
  React.useEffect(async () => {
    await setSendData(false);
    console.log("defaultValue index  ", defaultValue);
    if (defaultValue.arMainGroup !== "") {
      await setARMainGroup(defaultValue.arMainGroup);
    }

    try {
      if (defaultValue.arTableData.length > 0) {
        await setArTableData(defaultValue.arTableData);
      }
    } catch (error) {
      console.error();
    }
    return () => {};
  }, [defaultValue]);
  const resultData = async (provenance, value) => {
    await setSendData(true);
    if (provenance == "ARMainGroupInput") {
      await setARMainGroup(value);
    }
    if (provenance === "ARListCode") {
      await setArTableData(value);
    }
  };
  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <ARMainGroupInput
            label={
              title !== "" && typeof title !== "undefined"
                ? title
                : "กลุ่มลูกหนี้หลัก"
            }
            resultData={(e) => resultData("ARMainGroupInput", e)}
            inputType={"text"}
            keyDown={(e) => keyDown(e)}
            defaultValue={arMainGroup}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <ARListCode
            resultData={(e) => resultData("ARListCode", e)}
            defaultValue={arTableData}
          />
        </Grid>
      </Grid>
    </>
  );
}

ConditionARSelect.propTypes = {
  defaultValue: PropTypes.array,
  title: PropTypes.string,
};
